import { render, staticRenderFns } from "./Statistic.vue?vue&type=template&id=963a6fca&scoped=true&lang=pug&"
import script from "./Statistic.vue?vue&type=script&lang=ts&"
export * from "./Statistic.vue?vue&type=script&lang=ts&"
import style0 from "./Statistic.vue?vue&type=style&index=0&id=963a6fca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963a6fca",
  null
  
)

export default component.exports